import React from 'react';
import PropTypes from 'prop-types';

function TickIcon({ color = 'black', width = 12, height = 9, ...props }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 12 9"
      fill="none"
      {...props}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.66649 7.115L10.7945 0.986328L11.7378 1.92899L4.66649 9.00033L0.423828 4.75766L1.36649 3.81499L4.66649 7.115Z"
        fill={color}
      />
    </svg>
  );
}

TickIcon.propTypes = {
  color: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number
};

export default TickIcon;
